import { BranchDescription } from './description'
import { BranchTimeline } from './branch-timeline'
import { Branch } from '@basehub/data/replicache/index'

export const BranchOverview = ({ branch }: { branch: Branch }) => {
  return (
    <div className="flex flex-col justify-between" id="branch-timeline">
      {!branch.isDefault && <BranchDescription branch={branch} />}
      <BranchTimeline branch={branch} />
    </div>
  )
}
